import { BaseBillingEntity } from '/@/modules/billing/models/BaseBillingEntity';
import NumeralService from '/@/modules/core/app/services/NumeralService';
import { ColumnFormat } from '/@/modules/core/app/constants/data.constants';
import { BillingInvoiceStatus } from '/@/modules/billing/enums/BillingInvoiceStatus';
import dayjs from 'dayjs';
import { DateFormat } from '/@/modules/core/app/constants/date.constants';

export class BillingInvoice extends BaseBillingEntity {
  /**
   * @var {string}
   */
  adjustmentCreditNotes;

  /**
   * @var {number}
   */
  amountAdjusted;

  /**
   * @var {number}
   */
  amountDue;

  /**
   * @var {number}
   */
  amountPaid;

  /**
   * @var {number}
   */
  amountToCollect;

  /**
   * @var {string}
   */
  appliedCredits;

  /**
   * @var {string}
   */
  baseCurrencyCode;

  /**
   * @var {string}
   */
  creditsApplied;

  /**
   * @var {string}
   */
  currencyCode;

  /**
   * @var {string}
   */
  customerId;

  /**
   * @var {number}
   */
  date;

  /**
   * @var {string}
   */
  deleted;

  /**
   * @var {string}
   */
  dueDate;

  /**
   * @var {string}
   */
  dunningAttempts;

  /**
   * @var {string}
   */
  exchangeRate;

  /**
   * @var {string}
   */
  firstInvoice;

  /**
   * @var {string}
   */
  hasAdvanceCharges;

  /**
   * @var {string}
   */
  id;

  /**
   * @var {string}
   */
  isGifted;

  /**
   * @var {string}
   */
  issuedCreditNotes;

  /**
   * @var {string}
   */
  linkedOrders;

  /**
   * @var {string}
   */
  netTermDays;

  /**
   * @var {string}
   */
  object;

  /**
   * @var {number}
   */
  paidAt;

  /**
   * @var {string}
   */
  priceType;

  /**
   * @var {string}
   */
  recurring;

  /**
   * @var {string}
   */
  roundOffAmount;

  /**
   * @var {string}
   */
  status;

  /**
   * @var {number}
   */
  subTotal;

  /**
   * @var {string}
   */
  tax;

  /**
   * @var {string}
   */
  termFinalized;

  /**
   * @var {number}
   */
  total;

  /**
   * @var {number}
   */
  writeOffAmount;

  constructor(model = {}) {
    super(model);

    this.adjustmentCreditNotes = model.adjustmentCreditNotes;
    this.amountAdjusted = model.amountAdjusted;
    this.amountDue = model.amountDue;
    this.amountPaid = model.amountPaid;
    this.amountToCollect = model.amountToCollect;
    this.appliedCredits = model.appliedCredits;
    this.baseCurrencyCode = model.baseCurrencyCode;
    this.creditsApplied = model.creditsApplied;
    this.currencyCode = model.currencyCode;
    this.customerId = model.customerId;
    this.date = model.date;
    this.deleted = model.deleted;
    this.dueDate = model.dueDate;
    this.dunningAttempts = model.dunningAttempts;
    this.exchangeRate = model.exchangeRate;
    this.firstInvoice = model.firstInvoice;
    this.hasAdvanceCharges = model.hasAdvanceCharges;
    this.id = model.id;
    this.isGifted = model.isGifted;
    this.issuedCreditNotes = model.issuedCreditNotes;
    this.linkedOrders = model.linkedOrders;
    this.netTermDays = model.netTermDays;
    this.object = model.object;
    this.paidAt = model.paidAt;
    this.priceType = model.priceType;
    this.recurring = model.recurring;
    this.roundOffAmount = model.roundOffAmount;
    this.status = model.status;
    this.subTotal = model.subTotal;
    this.tax = model.tax;
    this.termFinalized = model.termFinalized;
    this.total = model.total;
    this.writeOffAmount = model.writeOffAmount;
  }

  /**
   * @returns {string}
   */
  get dateFormatted() {
    return dayjs.unix(this.date).format(DateFormat.ISO);
  }

  /**
   * @returns {string}
   */
  get amountPaidFormatted() {
    return NumeralService.formatValue(this.amountPaid / 100, ColumnFormat.FORMAT_CURRENCY);
  }

  /**
   * @returns {string}
   */
  get statusText() {
    return BillingInvoiceStatus.getByKey(this.status)?.value;
  }

  /**
   * @returns {boolean}
   */
  get isStatusPaid() {
    return this.status === BillingInvoiceStatus.PAID.key;
  }

  /**
   * @returns {string}
   */
  get statusTag() {
    switch (this.status) {
      case BillingInvoiceStatus.PAID.key:
        return 'is-success';
      default:
        return 'is-grey';
    }
  }
}
